export default __webpack_public_path__ + "static/media/008-tea.cd354248.svg";